import type { IQuarterlyBrazilianCompanyFinancials, IYearlyBrazilianCompanyFinancials } from "types/graphqlTypes";

type TCompanyFinancials = IQuarterlyBrazilianCompanyFinancials | IYearlyBrazilianCompanyFinancials;

export type TCompanyFinancialsClassification = {
  isQuarterly: boolean;
  isYearly: boolean;
  isBank: boolean;
  isCompany: boolean;
  isInsurer: boolean;
  isReit: boolean;
};

export default function classifyFinancialStatements(
  financials: TCompanyFinancials[],
): TCompanyFinancialsClassification {
  const isQuarterly = financials.every(({ __typename }) => {
    return (
      __typename === "QuarterlyBrazilianBankFinancialStatementRow" ||
      __typename === "QuarterlyBrazilianCompanyFinancialStatementRow" ||
      __typename === "QuarterlyBrazilianInsurerFinancialStatementRow"
    );
  });

  const isYearly = financials.every(({ __typename }) => {
    return (
      __typename === "YearlyBrazilianBankFinancialStatementRow" ||
      __typename === "YearlyBrazilianCompanyFinancialStatementRow" ||
      __typename === "YearlyBrazilianInsurerFinancialStatementRow"
    );
  });

  const isBank = financials.every(({ __typename }) => {
    return (
      __typename === "QuarterlyBrazilianBankFinancialStatementRow" ||
      __typename === "YearlyBrazilianBankFinancialStatementRow"
    );
  });

  const isCompany = financials.every(({ __typename }) => {
    return (
      __typename === "QuarterlyBrazilianCompanyFinancialStatementRow" ||
      __typename === "YearlyBrazilianCompanyFinancialStatementRow"
    );
  });

  const isInsurer = financials.every(({ __typename }) => {
    return (
      __typename === "QuarterlyBrazilianInsurerFinancialStatementRow" ||
      __typename === "YearlyBrazilianInsurerFinancialStatementRow"
    );
  });

  return {
    isQuarterly,
    isYearly,
    isBank,
    isCompany,
    isInsurer,
    isReit: false,
  };
}
